import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import * as experts from "./ducks/experts.duck";
import * as consumption from "./ducks/consumption.duck";
import { metronic } from "../../_metronic";

export const rootReducer = combineReducers({
    auth: auth.reducer,
    experts: experts.reducer,
    consumption: consumption.reducer,
    builder: metronic.builder.reducer,
});

export function* rootSaga() {
    yield all([auth.saga(), experts.saga(), consumption.saga()]);
}
